const GITHUB_API_KEY = "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";
const SMTP_HOST = "smtp.gmail.com";
const SMTP_PORT = "587";
const SMTP_USER = "support@glimmr.app";
const SMTP_PASSWORD = "qvogrsdhexznjjmk";
const SMTP_FROM = "Glimmr <support@glimmr.app>";
const LICENSE_MIN_PRICE = "1.99";
const LICENSE_MAX_PRICE = "5.99";
const STRIPE_SECRET_KEY = "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";
const STRIPE_PRODUCT_ID = "prod_RV174P8sBonywM";
export {
  GITHUB_API_KEY as G,
  LICENSE_MIN_PRICE as L,
  SMTP_HOST as S,
  LICENSE_MAX_PRICE as a,
  SMTP_PORT as b,
  SMTP_USER as c,
  SMTP_PASSWORD as d,
  SMTP_FROM as e,
  STRIPE_PRODUCT_ID as f,
  STRIPE_SECRET_KEY as g
};
